import CloserSvg from "@/assets/icons/closerSvg.svg";
import { IStatusProps } from "./Models";
import useImage from "use-image";
import { useState } from "react";
import { Rect } from "react-konva";
import { Html } from "react-konva-utils";
import { TOTAL_TILE_COLUMN } from "./BufferStart";

export const ClosedStatus = ({
  x,
  widthState,
  heightState,
  totalTile,
  height,
  toolTip,
  closeTimeText,
}: IStatusProps): JSX.Element => {
  const [image] = useImage(CloserSvg);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [widthElement, setWidthElement] = useState<number>(0);

  const handleMouseEnter = (e: any) => {
    const { x, y } = e.target.getStage().getPointerPosition();
    if (e.target.getStage()?.attrs?.width) {
      setWidthElement(e.target.getStage().attrs.width);
    }
    const position = {
      x: x,
      y: y - 60,
    };
    setTooltipVisible(true);
    setTooltipPosition(position);
  };

  const handleMouseMove = (e: any) => {
    const { x, y } = e.target.getStage().getPointerPosition();
    if (e.target.getStage()?.attrs?.width) {
      setWidthElement(e.target.getStage().attrs.width);
    }
    const position = {
      x: x,
      y: y - 60,
    };
    setTooltipPosition(position);
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };

  const positionTooltip = (): React.CSSProperties => {
    if (tooltipPosition.x > widthElement / 2) {
      return {
        right: widthElement - tooltipPosition.x,
      };
    }
    return {
      left: tooltipPosition.x,
    };
  };

  return (
    <>
      <Rect
        x={x}
        y={heightState - height + 4}
        width={(totalTile * widthState) / TOTAL_TILE_COLUMN}
        height={height - 1}
        // fill="rgba(127, 127, 127, 0.4)"
        stroke="#7F7F7F"
        fillPatternImage={image}
        onMouseEnter={handleMouseEnter}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      />
      <Html
        divProps={{
          style: {
            position: "relative",
          },
        }}
      >
        {tooltipVisible && (
          <div
            style={{
              position: "absolute",
              top: tooltipPosition.y,
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              color: "#fff",
              padding: "2px",
              borderRadius: "3px",
              fontSize: "11px",
              zIndex: 9999,
              ...positionTooltip(),
            }}
          >
            {closeTimeText}: {toolTip}
          </div>
        )}
      </Html>
    </>
  );
};
